import { useState } from 'react';

const NatoAlphabetTranslator = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const natoAlphabet = {
    'A': 'Alfa',
    'B': 'Bravo',
    'C': 'Charlie',
    'D': 'Delta',
    'E': 'Eco',
    'F': 'Foxtrot',
    'G': 'Golf',
    'H': 'Hotel',
    'I': 'India',
    'J': 'Julieta',
    'K': 'Kilo',
    'L': 'Lima',
    'M': 'Mike',
    'N': 'Noviembre',
    'O': 'Oscar',
    'P': 'Papa',
    'Q': 'Quebec',
    'R': 'Romeo',
    'S': 'Sierra',
    'T': 'Tango',
    'U': 'Uniforme',
    'V': 'Víctor',
    'W': 'Whiskey',
    'X': 'X-Ray',
    'Y': 'Yankee',
    'Z': 'Zulu',
    '0': 'Cero',
    '1': 'Uno',
    '2': 'Dos',
    '3': 'Tres',
    '4': 'Cuatro',
    '5': 'Cinco',
    '6': 'Seis',
    '7': 'Siete',
    '8': 'Ocho',
    '9': 'Nueve'
  };

  const handleInputChange = (e) => {
    const text = e.target.value.toUpperCase();
    const translatedText = text.split('').map((char) => {
      if (natoAlphabet[char]) {
        return natoAlphabet[char];
      }
      return char;
    }).join(' ');
    setInput(text);
    setOutput(translatedText);
  };




  const handleCopyClick = () => {
    navigator.clipboard.writeText(output);
  };



   
  const handleClear = () => {
    setInput('');
    setOutput('');
  };


      // Function to calculate text statistics
      const calculateTextStats = (text) => {
        const totalCharacters = text.length;
        const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
        const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
        const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
        const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
    
        return {
          totalCharacters,
          totalCharactersWithoutSpace,
          totalWords,
          totalParagraphs,
          totalSentences,
        };
      };
    
    
        // Calculate stats dynamically based on current binary value
    const stats = calculateTextStats(input);

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
  <textarea
    type="text"
    className="form-control mb-3"
    value={input}
    style={{ height: '10rem' }}
    onChange={handleInputChange}
    placeholder="Enter text to translate to NATO alphabet "
  />
     <h2 className="h5">Translated Text </h2>

  <textarea
        id="text"
        className="form-control mb-3"
        rows="4"
        value={output}
        style={{ height: '10rem' }}
        placeholder="Translated Text: "
        readOnly
      />

<div className="d-flex  align-items-center mb-3">
    <button
      className="btn btn-primary"
      onClick={handleCopyClick}
    >
      Click to Copy
    </button>
    <button
        className="btn btn-danger"
        onClick={handleClear}
      >
     Clear
      </button>
  </div>
  <div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>
</div>


  );
};

export default NatoAlphabetTranslator;